import React from "react";

export default () => (
    <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.0938 2.42383L14.7656 4.24902L12.6777 5.24414L11.5303 4.46094L4.29395 9.40332V21.75H18.7646V16.9775H20.7646V23.75H2.29395V10.7695L1.3877 11.3887L0.823242 10.5625L0.259766 9.73633L10.9658 2.42383L11.5293 2.03906L12.0938 2.42383Z"
            fill="#fff"
        />
        <path
            d="M19.765 1.625L21.9079 6.01075L26.3532 8.125L21.9079 10.2392L19.765 14.625L17.622 10.2392L13.1768 8.125L17.622 6.01075L19.765 1.625Z"
            stroke="#fff"
            strokeWidth="2"
            strokeLinejoin="bevel"
        />
    </svg>
);
